import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import { number, object, string } from "yup";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxWidth: "500px",
  //   maxHeight: "70vh",
  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const validation = object().shape({
  sayadNumber: number().min(16, "شماره صیاد باید 16 رقم باشد."),
  cheaqueSeries: number(),
  cheaqueSerial: number(),
  description: string()
    .ensure()
    .max(500, "توضیحات نباید بیش از 500 کاراکتر باشد."),
});

interface Props {
  open: boolean;
  setOpen: (arg: boolean) => void;
  handleCancel: Function;
  handleClose: Function;
  amount: number;
}

const CancelSettelmentModal = ({
  open,
  setOpen,
  handleCancel,
  amount,
  handleClose,
}: Props) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ width: "100%", marginBottom: "20px" }}>
          <Typography sx={{ fontSize: "1rem", textAlign: "center" }}>
            آیا از <span style={{ color: "#E6123D" }}>حذف درخواست پرداخت</span>{" "}
            با مبلغ{" "}
            <span style={{ color: "#E6123D" }}>
              {amount.toLocaleString("fa")} ریال
            </span>{" "}
            اطمینان دارید؟
          </Typography>
        </Box>

        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          marginBottom={"8px"}
        >
          <Grid item xs={6} width={"100%"} sx={{ paddingInline: "10px" }}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              className={"btnForm DangerDefault"}
              onClick={() => handleCancel()}
            >
              بله
            </Button>
          </Grid>
          <Grid item xs={6} width={"100%"} sx={{ paddingInline: "10px" }}>
            <Button
              onClick={() => handleClose()}
              fullWidth
              variant="contained"
              style={{
                fontSize: "1rem",
                color: "#fff",
                height: "40px",
                background: "#607D8B",
              }}
            >
              خیر
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CancelSettelmentModal;
